<script setup lang="ts">
import {RouterView} from 'vue-router';
import {onMounted} from 'vue';
import {getAppName, getAppVersion, getBackendUrl, getFrontendUrl, getSupertokensCoreUrl} from '@/base/frontendConfig';

onMounted(()=>{
    console.info(`INFO : App Name           = ${getAppName()}`);
    console.info(`INFO : App Version        = ${getAppVersion()}`);
    console.info(`INFO : FrontendUrl        = ${getFrontendUrl()}`);
    console.info(`INFO : BackendUrl         = ${getBackendUrl()}`);
    console.info(`INFO : SupertokensCoreUrl = ${getSupertokensCoreUrl()}`);
})
</script>

<template>
  <RouterView/>
</template>